import { useCallback, useState } from "react";

export const useTabSearchV3 = () => {
  const [elementSearch, setElementSearch] = useState("");
  const [cableSearch, setCableSearch] = useState("");
  const [boardSearch, setBoardSearch] = useState("");

  const clearElementSearch = useCallback(() => setElementSearch(""), []);

  return {
    elementSearch,
    setElementSearch,
    clearElementSearch,
    cableSearch,
    setCableSearch,
    boardSearch,
    setBoardSearch,
  };
};
